// Menu latéral (components/common/layout/MenuLateral) : les entrées sans
// `group` s'affichent d'abord, puis les groupes dans l'ordre de cet objet.
// Le rail n'affiche que les icônes : une icône par groupe et des icônes
// distinctes au sein d'un même bloc.
export const groups = {
  PARAMETERS: {
    id: "PARAMETERS",
    name: "Paramètres",
    icon: "cog",
  },
  CONTENT: {
    id: "CONTENT",
    name: "Contenu",
    icon: "newspaper",
  },

  ADVANCED: {
    id: "ADVANCED",
    name: "Avancé",
    icon: "tools",
  },
};
export const sidenavItems = [
  { name: "Accueil", path: "/dashboard", alias: ["/"], icon: "home" },
  {
    name: "Clients",
    path: "/client-list",
    icon: "users",
    dataPriv: "bo_searchclient",
  },

  {
    name: "Leads entreprise",
    path: "/leads",
    icon: "building",
    dataPriv: "bo_leadentrepriseactions",
  },
  {
    name: "Leads DOMI",
    path: "/leads-domi",
    icon: "map-marker-alt",
    dataPriv: "bo_viewusertempdomi",
  },
  {
    name: "Leads internes",
    path: "/leads-internes",
    icon: "user-tie",
    dataPriv: "bo_leadinterneactions",
  },
  {
    name: "Leads auto",
    path: "/leads-auto",
    icon: "car",
    dataPriv: "bo_leadentrepriseactions",
  },
  {
    name: "Renouvellement PJ",
    path: "/pj-renew",
    icon: "chess-rook",
    dataPriv: "bo_viewcontractdocs",
  },
  {
    name: "Simulateur PJ",
    path: "/simulator",
    icon: "calculator",
    dataPriv: "bo_usetarificator",
  },
  {
    name: "Documents",
    path: "/files",
    icon: "file-alt",
    dataPriv: "bo_searchfiles",
  },
  {
    name: "Guides d'utilisation",
    path: "/documentation",
    icon: "book-reader",
  },
  { name: "Ma timeline", path: "/timeline", icon: "heartbeat" },

  //ADVANCED
  {
    name: "Liste des commissions PJ",
    path: "/partner-commissions",
    icon: "handshake",
    dataPriv: "bo_readcommissions",
    group: groups.ADVANCED.id,
  },
  {
    name: "Liste RBE",
    path: "/rbe-list",
    icon: "user-shield",
    dataPriv: "bo_rbeactions",
    group: groups.ADVANCED.id,
  },
  {
    name: "Liste noire",
    path: "/black-list",
    icon: "ban",
    dataPriv: "bo_blacklistactions",
    group: groups.ADVANCED.id,
  },
  {
    name: "SFTP BFC",
    path: "/ftpclient",
    icon: "exchange-alt",
    dataPriv: "bo_crudtestimonials",
    group: groups.ADVANCED.id,
  },
  {
    name: "Effacement de données",
    path: "/effacements",
    icon: "user-slash",
    dataPriv: "bo_effacerdonneespersonnelles",
    group: groups.ADVANCED.id,
  },
  {
    name: "Jobs échoués",
    path: "/failed-jobs",
    icon: "exclamation-triangle",
    group: groups.ADVANCED.id,
    visibleIf: (user) => user?.email?.endsWith("@10positif.com"),
  },
  //GROUPE PARAMETRES
  {
    name: "Utilisateurs BO",
    path: "/users",
    icon: "user",
    dataPriv: "bo_crudusers",
    group: groups.PARAMETERS.id,
  },
  {
    name: "Rôles utilisateurs",
    path: "/roles",
    icon: "fingerprint",
    dataPriv: "bo_updaterolesconfig",
    group: groups.PARAMETERS.id,
  },
  {
    name: "Catégories de docs",
    path: "/document-categories",
    icon: "folder",
    dataPriv: "bo_crudfilecategory",
    group: groups.PARAMETERS.id,
  },
  {
    name: "Types de docs",
    path: "/file-types",
    icon: "file-excel",
    dataPriv: "bo_crudfiletype",
    group: groups.PARAMETERS.id,
  },
  {
    name: "Constantes",
    path: "/constants",
    icon: "balance-scale",
    dataPriv: "bo_viewparameters",
    group: groups.PARAMETERS.id,
  },
  // Interrupteurs de l'agent de tarification (PER-2434).
  {
    name: "Agent de tarification",
    path: "/agent-tarification",
    icon: "robot",
    dataPriv: "bo_viewparameters",
    group: groups.PARAMETERS.id,
  },

  //CONTENT
  {
    name: "Astuces PJ",
    path: "/hints",
    icon: "exclamation-circle",
    dataPriv: "bo_crudtestimonials",
    group: groups.CONTENT.id,
  },
  {
    name: "FAQ",
    path: "/faqs",
    icon: "question-circle",
    dataPriv: "bo_crudtestimonials",
    group: groups.CONTENT.id,
  },
  {
    name: "Pages dynamiques",
    path: "/dynamic-pages",
    icon: "file",
    dataPriv: "bo_modifypages",
    group: groups.CONTENT.id,
  },
  {
    name: "Témoignages",
    path: "/testimonials",
    icon: "bullhorn",
    dataPriv: "bo_crudtestimonials",
    group: groups.CONTENT.id,
  },
];
